import { Typography } from "antd";
import { Trans } from "react-i18next";
import dayjs from "dayjs";
import { useAppSelector } from "../../store";
import { currentDoctor } from "../../store/slices/user";

const { Paragraph } = Typography;

const PolicyText = ({ formValues }: { formValues: any }) => {
  const doctor = useAppSelector(currentDoctor);

  return (
    <div style={{ paddingTop: 16 }}>
      <Paragraph>
        <Trans i18nKey="dashboardPage.onboarding.paragraph1" />
      </Paragraph>
      <Paragraph>
        <Trans i18nKey="dashboardPage.onboarding.paragraph2" />
      </Paragraph>
      <Paragraph>
        <Trans i18nKey="dashboardPage.onboarding.paragraph3" />
      </Paragraph>
      <Paragraph>
        <Trans i18nKey="dashboardPage.onboarding.paragraph4" />
      </Paragraph>
      <Paragraph>
        <Trans
          i18nKey="dashboardPage.onboarding.paragraph5"
          components={{
            userName: <span>{formValues.name} {formValues.surname}</span>,
            birthPlace: <span>{formValues.birth_place}</span>,
            birthDate: <span>{dayjs(formValues.birth_date).format("DD/MM/YYYY").toString()}</span>,
            address: <span>{formValues.address}, {formValues.cap}, {formValues.province}</span>,
            codeFiscale: <span>{formValues.codFisc}</span>
          }}
        />
      </Paragraph>
      <ul style={{ paddingLeft: 16, listStyleType: "lower-alpha" }}>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list1" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list2" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list3" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list4" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list5" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list6" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list7" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list8" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list9" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list10" />
          <ul style={{ paddingLeft: 16, listStyleType: "default" }}>
            <li>
              <Trans i18nKey="dashboardPage.onboarding.list11" />
            </li>
            <li>
              <Trans i18nKey="dashboardPage.onboarding.list12" />
            </li>
          </ul>
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list13" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list14" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list15" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list16" />
        </li>
        <li>
          <Trans i18nKey="dashboardPage.onboarding.list17" />
        </li>
      </ul>
      <Paragraph>
        <Trans i18nKey="dashboardPage.onboarding.paragraph6" />
      </Paragraph>
      <Paragraph style={{ textAlign: "center" }}>
        <strong>dichiara</strong>
      </Paragraph>
      <Paragraph>
        <Trans i18nKey="dashboardPage.onboarding.paragraph7" />
      </Paragraph>
      <Paragraph style={{ textAlign: "center" }}>
        <strong>accetta</strong>
      </Paragraph>
      <Paragraph>
        <Trans
          i18nKey="dashboardPage.onboarding.paragraph8"
          components={{
            doctorName: <span>{doctor?.name} {doctor?.surname}</span>,
            doctorRegion: <span>{doctor?.alboRegion?.name}</span>,
            doctorPolicy: <span>{doctor?.albo_number}</span>
          }}
        />
      </Paragraph>
    </div>
  );
};

export default PolicyText;
